module.exports = __webpack_public_path__ + "img/ASCUS.959d032f.png";